import createCachedSelector from 're-reselect';

import {
  EntityStatus,
  RequestStatusType,
  User,
  UserFollowedLeadersListFields,
  YammerState,
  getStatus,
} from '../../state/types';
import { userFollowedLeadersListRequestStatusKey } from '../leadersManagement/actions.types';
import { getStatus as getRequestStatus } from '../requestStatuses/selectors';
import { getFulfilledUserFollowedLeaders } from '../userFollowedLeaders/selectors';
import { getFulfilledUsers } from '../users/selectors';

type GetLoadMoreUserFollowedLeadersListStatus = (state: YammerState) => EntityStatus;
export const getLoadMoreUserFollowedLeadersListStatus: GetLoadMoreUserFollowedLeadersListStatus = (state) =>
  getRequestStatus(
    state,
    RequestStatusType.UserFollowedLeadersListLoadMoreRequest,
    userFollowedLeadersListRequestStatusKey
  );

type GetUserFollowedLeadersListStatus = (state: YammerState) => EntityStatus;
export const getUserFollowedLeadersListStatus: GetUserFollowedLeadersListStatus = (state) =>
  getStatus(state.userFollowedLeadersList);

type GetUserFollowedLeadersListIdsFromState = (state: YammerState) => User['id'][];
export const getUserFollowedLeadersListIdsFromState: GetUserFollowedLeadersListIdsFromState = (state: YammerState) =>
  state.userFollowedLeadersList.fulfilled?.userFollowedLeaders ?? [];

type GetUserFollowedLeadersList = (state: YammerState) => UserFollowedLeadersListFields[];
export const getUserFollowedLeadersList: GetUserFollowedLeadersList = createCachedSelector(
  getUserFollowedLeadersListIdsFromState,
  getFulfilledUserFollowedLeaders,
  getFulfilledUsers,
  (userFollowedLeadersListIds, fulfilledUserFollowedLeaders, fulfilledUsers) =>
    userFollowedLeadersListIds.reduce<UserFollowedLeadersListFields[]>((acc, edgeId) => {
      const userFollowedLeader = fulfilledUserFollowedLeaders[edgeId];

      if (!userFollowedLeader) {
        throw new Error('Missing user followed leader data in state for user followed leaders list edge.');
      }

      const { id, totalFollowedUsers, totalFollowers, directAudienceCount } = userFollowedLeader;
      const { name, jobTitle, avatarUrlTemplate } = fulfilledUsers[id];

      acc.push({
        id,
        avatarUrlTemplate,
        name,
        jobTitle,
        totalFollowedUsers,
        totalFollowers,
        directAudienceCount,
      });

      return acc;
    }, [])
)((_state) => 'cache');

type HasNextPageOfUserFollowedLeadersListAvailable = (state: YammerState) => boolean;
export const hasNextPageOfUserFollowedLeadersListAvailable: HasNextPageOfUserFollowedLeadersListAvailable = (state) =>
  state.userFollowedLeadersList.fulfilled?.hasNextPage ?? false;

type GetUserFollowedLeadersOfficeIdList = (state: YammerState) => string[];
export const getUserFollowedLeadersOfficeIdList: GetUserFollowedLeadersOfficeIdList = createCachedSelector(
  getUserFollowedLeadersListIdsFromState,
  getFulfilledUserFollowedLeaders,
  (userFollowedLeadersListIds, fulfilledUserFollowedLeaders) =>
    userFollowedLeadersListIds.reduce<string[]>((acc, edgeId) => {
      const userFollowedLeader = fulfilledUserFollowedLeaders[edgeId];

      if (!userFollowedLeader) {
        throw new Error('Missing user Fofollowedllowed leader data in state for user followed leaders list edge.');
      }

      const { officeUserId } = userFollowedLeader;
      if (officeUserId) {
        acc.push(officeUserId);
      }

      return acc;
    }, [])
)((_state) => 'cache');
